import React from 'react';
import IOSSecurityDemo from './IOSSecurityDemo-i18n';
import './i18n';

function App() {
  return (
    <div className="App">
      <IOSSecurityDemo />
    </div>
  );
}

export default App;
